import React from 'react';
import { PriceDisplay } from './PriceDisplay';
import { CheckCircleIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
export function PricingOffer() {
  const features = ['+7.000 patrones en PDF descargable al instante', '6 bonos exclusivos valorados en $127.000 ARS (incluidos gratis)', 'Instrucciones paso a paso con gráficos detallados', 'Acceso inmediato (descarga en menos de 24 hs)', 'Compatible con celular, tablet y computadora'];
  return <section className="w-full py-16 px-4 bg-gradient-to-b from-cream to-white" data-id="element-71">
      <div className="max-w-4xl mx-auto" data-id="element-72">
        {/* Badge */}
        <div className="text-center mb-6" data-id="element-73">
          <span className="inline-block bg-accent text-gray-900 font-heading font-bold px-6 py-2 rounded-full text-sm md:text-base" data-id="element-74">
            +2000 descargas
          </span>
        </div>

        {/* Main Offer Card */}
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-4 border-primary" data-id="element-75">
          <div className="bg-primary text-white py-6 px-6 text-center" data-id="element-76">
            <h2 className="font-heading font-bold text-2xl md:text-3xl" data-id="element-77">
              CREA CON HILOS – 7.000 PATRONES + 6 BONOS
            </h2>
          </div>

          <div className="p-8 md:p-12" data-id="element-78">
            {/* Pricing */}
            <div className="mb-8" data-id="element-79">
              <PriceDisplay originalPrice={35000} salePrice={17999} currency="ARS" data-id="element-80" />
            </div>

            {/* CTA Button */}
            <a href="[CART_LINK]" className="block w-full bg-primary hover:bg-opacity-90 text-white font-heading font-bold text-xl py-5 rounded-full shadow-lg text-center transition-all duration-300 transform hover:scale-105 mb-8" data-id="element-81">
              COMPRAR AHORA
            </a>

            {/* What's Included */}
            <div className="space-y-3 mb-8" data-id="element-82">
              {features.map((feature, index) => <div key={index} className="flex items-start gap-3" data-id="element-83">
                  <CheckCircleIcon className="w-6 h-6 text-success flex-shrink-0 mt-1" aria-hidden="true" data-id="element-84" />
                  <p className="font-body text-base md:text-lg text-gray-700" data-id="element-85">
                    {feature}
                  </p>
                </div>)}
            </div>

            {/* Trust Badges */}
            <div className="flex flex-wrap justify-center items-center gap-6 pt-6 border-t border-gray-200" data-id="element-86">
              <div className="flex items-center gap-2 text-gray-600" data-id="element-87">
                <ShieldCheckIcon className="w-6 h-6 text-secondary" aria-hidden="true" data-id="element-88" />
                <span className="font-body text-sm" data-id="element-89">Compra Segura</span>
              </div>
              <div className="flex items-center gap-2 text-gray-600" data-id="element-90">
                <CreditCardIcon className="w-6 h-6 text-secondary" aria-hidden="true" data-id="element-91" />
                <span className="font-body text-sm" data-id="element-92">Pago Protegido</span>
              </div>
            </div>
          </div>
        </div>

        {/* Guarantee */}
        <div className="mt-8 bg-success/10 border-2 border-success rounded-2xl p-6 text-center" data-id="element-93">
          <p className="font-heading font-bold text-xl md:text-2xl text-gray-900 mb-2" data-id="element-94">
            👉 Probalo 7 días sin riesgo
          </p>
          <p className="font-body text-base md:text-lg text-gray-700" data-id="element-95">
            Si no te gusta o no es para vos, te devolvemos el 100% de tu dinero.
            Sin preguntas.
          </p>
        </div>
      </div>
    </section>;
}